import { ReferralFormData } from '../context';
import { TaxServiceOptions } from '../enums';
import { FormTracker } from '@rs/form-tracking-sdk';
import { formTracker } from '../../../shared/utils';

function logGAEvents(
  referenceId: string,
  referral: ReferralFormData,
  localFormTracker: FormTracker = formTracker
) {
  // Tax interests
  if (referral?.interests?.includes(TaxServiceOptions.personal_taxes.value)) {
    localFormTracker.trackModule({
      type: 'form_option',
      category: 'tax_interest',
      label: 'individual_family',
      value: 0
    });
  }
  if (referral?.interests?.includes(TaxServiceOptions.small_business.value)) {
    localFormTracker.trackModule({
      type: 'form_option',
      category: 'tax_interest',
      label: 'small_business',
      value: 0
    });
  }

  // Submission
  localFormTracker.trackModule({
    type: 'lead',
    category: 'tax',
    label: 'primary',
    value: 0
  });
  localFormTracker.trackValidSubmission();
  localFormTracker.trackConfirmation({
    referenceId
  });
}

export { logGAEvents };
